module.exports = __webpack_public_path__ + "assets/clear_map_white.a8cb2f38.svg";